import { Button, EyeInvisibleOutlined, EyeTwoTone } from "@monbits/ui";
import * as React from "react";
import useWindowSize from "src/hooks/use-window-size";
import copyToClipboard from "src/utils/copy-to-clipboard";

interface Props {
	text: string;
	width?: number;
	popupFunc: (title: string, desc: string) => void;
}

const PasswordLabel: React.FC<Props> = (props: Props) => {
	const windowSize = useWindowSize();
	const [visible, setVisible] = React.useState<boolean>(false);
	const securedString = React.useRef("*".repeat(props.text.length));

	const copyText = () => {
		if (visible) {
			copyToClipboard(props.text, props.popupFunc);
		}
	};

	const stripPassword = () => {
		if (!windowSize?.width) {
			return null;
		}

		const curWindowSize: number = windowSize.width;

		if (curWindowSize && curWindowSize <= 1300) {
			return `${props.text.slice(0, 15)}...${props.text.slice(-15)}`;
		}

		return props.text;
	};

	const stripSecureText = () => {
		if (!windowSize?.width) {
			return null;
		}

		const curWindowSize: number = windowSize.width;

		if (curWindowSize && curWindowSize <= 1300) {
			return securedString.current.slice(0, 40);
		}

		return securedString.current;
	};

	return (
		<div className="flex items-center gap-2">
			{visible ? (
				<>
					<Button
						variant="ghost"
						className="font-mono text-sm px-3 py-1 h-auto hover:bg-muted"
						onClick={copyText}
					>
						{stripPassword()}
					</Button>
					<Button
						variant="ghost"
						size="icon"
						aria-label="Hide value"
						className="h-8 w-8"
						onClick={() => setVisible(false)}
					>
						<EyeTwoTone className="h-4 w-4" />
					</Button>
				</>
			) : (
				<>
					<Button
						variant="ghost"
						className="font-mono text-sm px-3 py-1 h-auto hover:bg-muted"
						onClick={copyText}
					>
						{stripSecureText()}
					</Button>
					<Button
						variant="ghost"
						size="icon"
						aria-label="Show value"
						className="h-8 w-8"
						onClick={() => setVisible(true)}
					>
						<EyeInvisibleOutlined className="h-4 w-4" />
					</Button>
				</>
			)}
		</div>
	);
};

export default PasswordLabel;
